import { useConfirmationModal } from '#/components/basic/modal/ConfirmationModal';
import { useSelector } from '#/reduxState/store';

import { cancelAllOrdersWithSignModal } from './orderCancelUtils';

export function useCancelAllOrders(market?: string | false) {
  const wallet = useSelector(state => state.wallet);
  const delegatedAuthorization = useSelector(
    state => state.delegatedKey.authorization
  );

  const [cancelAllModalPlaceholder, showCancelAllConfirmation] =
    useConfirmationModal({
      title: 'Cancel All Orders',
      message: 'All orders will be canceled.',
      confirmText: 'Cancel All Orders',
      confirmButtonProps: {
        bordered: true,
        color: 'red',
        autoFocus: true,
      },
      onConfirm: async () => {
        await cancelAllOrdersWithSignModal(
          market || false,
          wallet,
          delegatedAuthorization
        );
      },
    });
  return {
    cancelAllModalPlaceholder,
    showCancelAllConfirmation,
  };
}
